module.exports = "<!-- <c-nav-tab></c-nav-tab>\r\n<router-outlet #o=\"outlet\"></router-outlet> -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/sample/sample.component.html
// module id = ./src/app/features/sample/sample.component.html
// module chunks = main